var exports = {
  "c6": "thinkingContent__tp1dEZ",
  "i1": "previewContainer__zAdETa",
  "m3": "previewSeparator__4TFUng",
  "VH": "preview__jAW-kv",
};

module.exports = exports;
